import { get } from 'lodash';

// local dependencies
import { HttpService } from 'core/modules/network-service';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';
import { getVisibleItems } from 'resolvers/getVisibleEntities';

/*************************************************************/

/**
 * @type {class}
 * @desc ActionItemDetailInnerWidget defines an HTTP service interface to send HTTP network requets.
 * @example
 * import { ActionItemDetailInnerWidgetService } from 'services/actionItemDetailInnerWidget';
 *
 * // create service instance and send/cancel request
 * const actionItemDetailInnerWidgetService = new ActionItemDetailInnerWidgetService();
 * const result = await actionItemDetailInnerWidgetService.fetchData( '<user-id>' ); // fetch data
 * actionItemDetailInnerWidgetService.cancel(); // cancel an active request
 */
export class ActionItemDetailInnerWidgetService extends HttpService {

    // make request and fetch data
    async fetchComponentData( { url = {}, data = {} } = {} ) {

        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data: data,
            } );
            
            // extract widgets from the response
            const visibility = get( response, 'body.component.visibility', {} );
            const widgets = get( response, 'body.component.structure.widgets', [] );

            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                data: {
                    widgets: getVisibleItems( widgets, visibility ),
                },
            };
        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE,
                data: null,
            };
        }
    }
}
